import { render, staticRenderFns } from "./TherapyTerms.vue?vue&type=template&id=51402b24"
import script from "./TherapyTerms.vue?vue&type=script&lang=js"
export * from "./TherapyTerms.vue?vue&type=script&lang=js"
import style0 from "./TherapyTerms.vue?vue&type=style&index=0&id=51402b24&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports